/* @ngInject */
const railwayCtrl = (
  $scope,
  $$railway,
  $$wagon,
) => {
  $scope.$$railway = $$railway
  $scope.$$wagon = $$wagon
}

export default railwayCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/railway/railway.controller.js